import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../lib/api";

export function useServers(projectId) {
  return useQuery({
    queryKey: ["servers", projectId],
    queryFn: async () => (await apiClient.get(`/projects/${projectId}/servers`)).data,
    enabled: !!projectId,
  });
}

function useInvalidateServers(projectId) {
  const queryClient = useQueryClient();
  return () => {
    queryClient.invalidateQueries({ queryKey: ["servers", projectId] });
  };
}

export function useSaveServer(projectId) {
  const invalidate = useInvalidateServers(projectId);
  return useMutation({
    mutationFn: async ({ serverId, ...body }) => {
      if (serverId) {
        return (await apiClient.put(`/projects/${projectId}/servers/${serverId}`, body)).data;
      }
      return (await apiClient.post(`/projects/${projectId}/servers`, body)).data;
    },
    onSuccess: invalidate,
  });
}

export function useDeleteServer(projectId) {
  const invalidate = useInvalidateServers(projectId);
  return useMutation({
    mutationFn: async (serverId) => (await apiClient.delete(`/projects/${projectId}/servers/${serverId}`)).data,
    onSuccess: invalidate,
  });
}

export function useTestServer(projectId) {
  const invalidate = useInvalidateServers(projectId);
  return useMutation({
    mutationFn: async (serverId) =>
      (await apiClient.post(`/projects/${projectId}/servers/${serverId}/test`)).data,
    onSettled: invalidate,
  });
}

export function useResetFingerprint(projectId) {
  const invalidate = useInvalidateServers(projectId);
  return useMutation({
    mutationFn: async (serverId) =>
      (await apiClient.post(`/projects/${projectId}/servers/${serverId}/reset-fingerprint`)).data,
    onSuccess: invalidate,
  });
}

export function errorMessage(error, fallback) {
  return error?.response?.data?.detail || fallback;
}
